export var CustomerInclType;
(function (CustomerInclType) {
    CustomerInclType[CustomerInclType["ALL"] = 1] = "ALL";
    CustomerInclType[CustomerInclType["INCLUDE"] = 2] = "INCLUDE";
    CustomerInclType[CustomerInclType["EXCLUDE"] = 3] = "EXCLUDE";
})(CustomerInclType || (CustomerInclType = {}));
//# sourceMappingURL=customer-incl-type.js.map